import { render, staticRenderFns } from "./HppBlockquote.vue?vue&type=template&id=62e6ab4c&scoped=true&"
import script from "./HppBlockquote.vue?vue&type=script&lang=js&"
export * from "./HppBlockquote.vue?vue&type=script&lang=js&"
import style0 from "./HppBlockquote.vue?vue&type=style&index=0&id=62e6ab4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e6ab4c",
  null
  
)

export default component.exports